import { ArrowForward } from '@material-ui/icons';
import Signal from '../components/shared/Signal';
import { checkValueExists } from '../utility/common';
const getCurrentAndProjectedHtml = ({ current, projected }) => {
  const curr = checkValueExists(current) ? current : null;
  const proj = checkValueExists(projected) ? projected : null;
  return (
    <div className="score-wrapper d-flex">
      {!curr && !proj ? '--' : null}
      {curr ? (
        <div className="current d-flex">
          <Signal value={curr} />
          <span className="Score">{curr}</span>
        </div>
      ) : null}
      {curr && proj ? <ArrowForward className="arrow" /> : null}
      {proj ? (
        <>
          <div className="projected d-flex">
            <Signal value={proj} />
            <span className="Score">{proj}</span>
          </div>{' '}
        </>
      ) : null}
    </div>
  );
};

export const EDITOR_TYPES = {
  GUTENBERG: 'GUTENBERG',
  TINYMCE: 'TINYMCE',
  CLASSIC: 'CLASSIC',
};

export const isWordPressEditor = (type) => type === EDITOR_TYPES.GUTENBERG || type === EDITOR_TYPES.CLASSIC;

// Instruction to request Gutenberg block format from AI (for rewrite content in Gutenberg editor)
export const GUTENBERG_FORMAT_INSTRUCTION = `

CRITICAL OUTPUT FORMAT REQUIREMENT: You MUST return the rewritten content in WordPress Gutenberg block format with proper block comment markers.

Each block MUST be wrapped with the appropriate WordPress block comments:
- For paragraphs: <!-- wp:paragraph --><p>Your paragraph text here</p><!-- /wp:paragraph -->
- For H2 headings: <!-- wp:heading {"level":2} --><h2>Your H2 heading</h2><!-- /wp:heading -->
- For H3 headings: <!-- wp:heading {"level":3} --><h3>Your H3 heading</h3><!-- /wp:heading -->
- For H4 headings: <!-- wp:heading {"level":4} --><h4>Your H4 heading</h4><!-- /wp:heading -->
- For bullet lists: <!-- wp:list --><ul><li>Item 1</li><li>Item 2</li></ul><!-- /wp:list -->
- For numbered lists: <!-- wp:list {"ordered":true} --><ol><li>Item 1</li><li>Item 2</li></ol><!-- /wp:list -->

IMPORTANT:
- Preserve the EXACT same block types as the input (if input has H3, output must have H3)
- Each block must have BOTH opening and closing comments
- Do NOT add any extra text, explanations, or markdown outside the Gutenberg blocks
- Return ONLY the Gutenberg-formatted blocks, nothing else`;

export const CR_LIST_FIELDS = {
  RANK: 'Rank',
  ID: 'Id',
  KEYWORD_RELEVANCE_RECOMMENDATIONS: 'Page URL',
  STATUS: 'Status',
  ORGANIC_CLICKS: 'Organic Clicks [Monthly]',
  ORGANIC_IMPRESSIONS: 'Organic Impressions [Monthly]',
  PAID_CLICKS: 'Paid Clicks [Monthly]',
  PAID_IMPRESSIONS: 'Paid Impressions [Monthly]',
  ADDITIONAL_CLICKS_OPPORTUNITY_LOW: 'Additional Clicks Opportunity - Low [%]',
  ADDITIONAL_CLICKS_OPPORTUNITY_HIGH: 'Additional Clicks Opportunity - High [%]',
  // TOP_RANKING_FACTORS: 'Top Ranking Factors (Rank)',
  RELEVANCE_SCORE: 'Relevance Score (Rank)',
  CONTENT_QUALITY: 'Content Quality (Rank)',
  LAST_UPDATED_DATE: 'Last Updated Date',
  // STEEPER_STATUS: 'Status',
};
export const CR_LIST_FIELDS_GRID = {
  mainHeading: [],
  subHeading: {
    // rank: {
    //   name: CR_LIST_FIELDS.RANK,
    //   className: 'cr-list-tbl-rank',
    //   showCustomComponent: true,
    //   isSort: true,
    // },

    keywordRelevanceRecommendations: {
      name: CR_LIST_FIELDS.KEYWORD_RELEVANCE_RECOMMENDATIONS,
      className: 'cr-list-keywords-relevance-recommendations',
      showCustomComponent: true,
      isSort: true,
    },
    status: {
      name: CR_LIST_FIELDS.STATUS,
      className: 'cr-list-status',
      showCustomComponent: true,
      isSort: true,
    },
    keywordRelevance: {
      name: CR_LIST_FIELDS.RELEVANCE_SCORE,
      className: 'cr-list-keyword-relavnce',
      showCustomComponent: true,
      isSort: true,
    },
    contentQuality: {
      name: CR_LIST_FIELDS.CONTENT_QUALITY,
      className: 'cr-list-content-quality',
      showCustomComponent: true,
      isSort: true,
    },
    organicClicks: {
      name: CR_LIST_FIELDS.ORGANIC_CLICKS,
      className: 'cr-list-organic-clicks',
      showCustomComponent: true,
      isSort: true,
    },
    organicImpressions: {
      name: CR_LIST_FIELDS.ORGANIC_IMPRESSIONS,
      className: 'cr-list-organic-impressions',
      showCustomComponent: true,
      isSort: true,
    },
    padiClicks: {
      name: CR_LIST_FIELDS.PAID_CLICKS,
      className: 'cr-list-paid-clicks',
      showCustomComponent: true,
      isSort: true,
    },
    padiImpressions: {
      name: CR_LIST_FIELDS.PAID_IMPRESSIONS,
      className: 'cr-list-paid-impressions',
      showCustomComponent: true,
      isSort: true,
    },
    lastUpdatedDate: {
      name: CR_LIST_FIELDS.LAST_UPDATED_DATE,
      className: 'cr-list-last-updated-date',
      showCustomComponent: true,
      isSort: true,
    },
    additionalCliksOpportunityLow: {
      name: CR_LIST_FIELDS.ADDITIONAL_CLICKS_OPPORTUNITY_LOW,
      className: 'cr-list-additional-clicks',
      showCustomComponent: true,
      isSort: true,
    },
    additionalCliksOpportunityHigh: {
      name: CR_LIST_FIELDS.ADDITIONAL_CLICKS_OPPORTUNITY_HIGH,
      className: 'cr-list-additional-clicks',
      showCustomComponent: true,
      isSort: true,
    },
    id: {
      name: CR_LIST_FIELDS.ID,
      className: 'cr-list-tbl-id',
      showCustomComponent: true,
      isSort: true,
    },
    // topRankingFactor: {
    //   name: CR_LIST_FIELDS.TOP_RANKING_FACTORS,
    //   className: 'cr-list-top-factor-ranking',
    //   showCustomComponent: true,
    //   isSort: true,
    // },
    // steeperStatus: {
    //   name: CR_LIST_FIELDS.STEEPER_STATUS,
    //   className: 'cr-list-status',
    //   showCustomComponent: true,
    //   isSort: true,
    // },
  },
};
export const INTENT_ALIGNMENT_TBL = {
  KEYWORD_CLUSTER: 'Keyword Cluster',
  KEYWORD_TYPE: '',
  No_OF_KEYWORDS: 'Keywords', // old name is "No Of Keywords"
  KEYWORD_IMPORTANCE: 'Keyword Importance',
  INTENT_EMPHASIS: 'Relevance Score', //"Intent Emphasis", //OLD NAME
  EMPHASIS_RANK: 'Relevance Rank', //"Emphasis Rank",  //  OLD NAME
  AVERAGE_ORGANIC_POSITION: 'Average Organic Position',
  IMPRESSION_CLICKS_ORG: 'Impression & Clicks [Organic]',
  CTR: 'CTR',
  IMPRESSION_CLICKS_PAID: 'Impression & Clicks [Paid]',
  CPC: 'CPC',
  CPA: 'CPA',
  CLUSTER_COUNT: 'Cluster Count',
  ORG_CLICKS: 'Organic Clicks',
  PAID_CLICKS: 'Paid Clicks',
  INTENT_EMPHASIS_DELTA: 'Intent Relevance Delta',
  EMPHASIS_RANK_OLD: 'Relevance Rank Old',
  ORG_IMPRESSIONS: 'Organic Impressions',
  PAID_IMPRESSIONS: 'Paid Impressions',
  EXTENDED_AVERAGE_CPC: 'Average CPC',
  EXTENDED_AVERAGE_SEARCH_VOLUME: 'Average Search Volume',
  EXTENDED_KEYWORD_DIFFICULTY: 'Keyword Difficulty',
};
const formatValue = {
  prefix: '',
  suffix: '',
  decimal: 2,
  inToPercentage: 1, // multiply by 1
};
export const INTENT_GRID_DETAILS = {
  mainHeading: [
    { name: '', group: 4, className: 'header-group' }, // Name empty to skip some Num of columns for grouping
    {
      name: 'Alignment',
      group: 3,
      // info: 'These are Quattr metrics that analyze your keyword clusters. Keyword Importance is first looking at the overall size of a given cluster taking into consideration impressions and number of keywords. Relevance Score measures how strong your content is optimized for that particular cluster. Relevance Rank looks at where you stand in relation to other sites in terms of who is the most targeted for a given keyword cluster.',
      className: 'header-group alignment',
    },
    {
      name: 'Organic Performance',
      group: 4,
      // info: 'These are all of your Google Search Console metrics from the past 30 days grouped by the Keyword Clusters mapped to this page.',
      className: 'header-group organic',
    },
    {
      name: 'Paid Performance',
      group: 4,
      // info: 'These are all of your Google Search Console metrics from the past 30 days grouped by the Keyword Clusters mapped to this page.',
      className: 'header-group paid',
      //hideOnScWidth: 1280,
    },
    {
      name: 'Extended Performance',
      group: 3,
      // info: 'Group of Extended Performance scores',
      className: 'header-group extended grey-background',
      //hideOnScWidth: 1280,
    },
    { name: 'Sections', group: 3, className: 'header-group1 sections', sectionAction: true }, // Name empty to skip some Num of columns for grouping
  ],
  subHeading: {
    keywordCluster: {
      name: INTENT_ALIGNMENT_TBL.KEYWORD_CLUSTER,
      followedBy: [INTENT_ALIGNMENT_TBL.CLUSTER_COUNT],
      showStar: true,
      className: 'intent-alignment-keyword capitalize-content',
      isSort: true,
    },
    keywordType: {
      name: INTENT_ALIGNMENT_TBL.KEYWORD_TYPE,
      className: 'keyword-source',
      isHidden: false,
      isSort: false,
      parentDefault: '',
      subRowDefault: '',
    },
    NoOfKeywords: {
      name: INTENT_ALIGNMENT_TBL.No_OF_KEYWORDS,
      className: 'no-of-keywords',
      isSort: true,
      showNewBadge: true,
    },
    keywordImportance: {
      name: INTENT_ALIGNMENT_TBL.KEYWORD_IMPORTANCE,
      isSort: true,
      showLineProgress: true,
      className: 'intent-alignment-importance',
    },
    IntentEmphasis: {
      name: INTENT_ALIGNMENT_TBL.INTENT_EMPHASIS,
      isSort: true,
      showSignal: true,
      deltaScore: INTENT_ALIGNMENT_TBL.INTENT_EMPHASIS_DELTA,
      projectedScore: 'Projected',
      className: 'intent-alignment-emphasis',
      showCustomRow: getCurrentAndProjectedHtml,
      customRowParams: [
        { dataKey: '_current', passKey: 'current' },
        { dataKey: '_projected', passKey: 'projected' },
      ],
    },
    intentEmphasisProjected: {
      name: 'Projected',
      isHide: true,
    },
    emphasisRank: {
      name: INTENT_ALIGNMENT_TBL.EMPHASIS_RANK,
      showProjectedRank: true,
      oldRank: INTENT_ALIGNMENT_TBL.EMPHASIS_RANK_OLD,
      isSort: true,
      className: 'intent-alignment-emp-rank',
    },
    avgOrgPosition: {
      name: INTENT_ALIGNMENT_TBL.AVERAGE_ORGANIC_POSITION,
      isSort: true,
      formatValue: { ...formatValue },
      className: 'intent-alignment-avg-position',
      subRowDefault: '--',
    },
    orgImpressions: {
      name: INTENT_ALIGNMENT_TBL.ORG_IMPRESSIONS,
      isSort: true,
      className: 'impressions',
      subRowDefault: '--',
      //hideOnScWidth: 1280,
    },
    orgClicks: {
      name: INTENT_ALIGNMENT_TBL.ORG_CLICKS,
      isSort: true,
      className: 'clicks',
      subRowDefault: '--',
      //hideOnScWidth: 1280,
    },
    // icOrganic: {
    //   name: INTENT_ALIGNMENT_TBL.IMPRESSION_CLICKS_ORG,
    //   // followedBy: [INTENT_ALIGNMENT_TBL.ORG_CLICKS],
    //   isSort: true,
    //   subLine: true,
    //   formatValue: { ...formatValue },
    //   className: "intent-alignment-imp-click-organic",
    //   subRowDefault: "--",
    // },
    ctr: {
      name: INTENT_ALIGNMENT_TBL.CTR,
      isSort: true,
      formatValue: {
        ...formatValue,
        decimal: 1,
        suffix: '%',
        inToPercentage: 100,
      },
      className: 'intent-alignment-ctr',
      subRowDefault: '--',
    },
    paidImpressions: {
      name: INTENT_ALIGNMENT_TBL.PAID_IMPRESSIONS,
      isSort: true,
      className: 'impressions',
      subRowDefault: '--',
      //hideOnScWidth: 1280,
    },
    paidClicks: {
      name: INTENT_ALIGNMENT_TBL.PAID_CLICKS,
      isSort: true,
      className: 'clicks',
      subRowDefault: '--',
      //hideOnScWidth: 1280,
    },
    // icPaid: {
    //   name: INTENT_ALIGNMENT_TBL.IMPRESSION_CLICKS_PAID,
    //   // followedBy: [INTENT_ALIGNMENT_TBL.PAID_CLICKS],
    //   isSort: true,
    //   subLine: true,
    //   formatValue: { ...formatValue },
    //   className: "intent-alignment-imp-click-paid",
    //   subRowDefault: "--",
    //   hideOnScWidth: 1280,
    // },
    cpc: {
      name: INTENT_ALIGNMENT_TBL.CPC,
      isSort: true,
      formatValue: { ...formatValue, decimal: 1, prefix: '$' },
      className: 'intent-alignment-cpc',
      subRowDefault: '--',
      //hideOnScWidth: 1280,
    },
    cpa: {
      name: INTENT_ALIGNMENT_TBL.CPA,
      isSort: true,
      formatValue: { ...formatValue, decimal: 1, prefix: '$' },
      className: 'intent-alignment-cpa',
      subRowDefault: '--',
      //hideOnScWidth: 1280,
    },
    clusterCount: {
      isHide: true,
      name: INTENT_ALIGNMENT_TBL.CLUSTER_COUNT,
    },
    intentEmphasisDelta: {
      isHide: true,
      name: INTENT_ALIGNMENT_TBL.INTENT_EMPHASIS_DELTA,
    },
    emphasisRankOld: {
      isHide: true,
      name: INTENT_ALIGNMENT_TBL.EMPHASIS_RANK_OLD,
    },
    avgCPC: {
      isHide: false,
      formatValue: { ...formatValue, decimal: 2, prefix: '$' },
      name: INTENT_ALIGNMENT_TBL.EXTENDED_AVERAGE_CPC,
      isSort: true,
      className: 'extended-performance-avg-cpc grey-background',
    },
    avgSearchValue: {
      isHide: false,
      name: INTENT_ALIGNMENT_TBL.EXTENDED_AVERAGE_SEARCH_VOLUME,
      isSort: true,
      className: 'extended-performance-avg-serch-volume grey-background',
    },
    keywordDifficulty: {
      isHide: false,
      name: INTENT_ALIGNMENT_TBL.EXTENDED_KEYWORD_DIFFICULTY,
      isSort: true,
      className: 'extended-performance-keyword-difficulty grey-background',
      ShowKeywordDifficultyScoreCircal: true,
    },
    isAction: {
      name: 'Action',
      conditionColumn: INTENT_ALIGNMENT_TBL.INTENT_EMPHASIS,
      title: 'Improve',
      className: 'keyword-list-action-column',
    },
  },
};

export const INTERACTIVE_TBL_HEADERS = {
  KEYWORD_CLUSTER: 'Keyword Cluster',
  // No_OF_KEYWORDS: 'Cluster Size', // old name is "No Of Keywords"
  KEYWORD_IMPORTANCE: 'Keyword Importance',
  KEYWORD_RELEVANCE_SCORE: 'Keyword Relevance Score', //"Intent Emphasis", //OLD NAME
  CONTENT_QUALITY_SCORE: 'Content Quality Score',
  // IMPROVE_SECTION: 'Improve',
  AVERAGE_ORGANIC_POSITION: 'Average Position',
  IMPRESSION_CLICKS_ORG: 'Organic Impressions',
  CTR: 'CTR',
  IMPRESSION_CLICKS_PAID: 'Paid Impression',
  CPC: 'CPC',
  CPA: 'CPA',
  CLUSTER_COUNT: 'Cluster Count',
  ORG_CLICKS: 'Organic Clicks',
  PAID_CLICKS: 'Paid Clicks',
  INTENT_EMPHASIS_DELTA: 'Intent Relevance Delta',
  EMPHASIS_RANK_OLD: 'Relevance Rank Old',
  ORG_IMPRESSIONS: 'Organic Impressions',
  PAID_IMPRESSIONS: 'Paid Impressions',
  EXTENDED_AVERAGE_CPC: 'Average CPC',
  EXTENDED_AVERAGE_SEARCH_VOLUME: 'Average Search Volume',
  EXTENDED_KEYWORD_DIFFICULTY: 'Keyword Difficulty',
};

// export const getInteractiveGridDetails = (isCNP) => {
//   const mainHeading = [
//     {
//       name: 'Branded',
//       showCustomContent: true,
//       colSpan: 3,
//       className: 'branded-header right-box-shadow sticky-column',
//       left: 5.5,
//     },
//     {
//       name: 'Page Insights',
//       showCustomContent: false,
//       colSpan: 3,
//       // info: 'These are Quattr metrics that analyze your keyword clusters. Keyword Importance is first looking at the overall size of a given cluster taking into consideration impressions and number of keywords. Relevance Score measures how strong your content is optimized for that particular cluster. Relevance Rank looks at where you stand in relation to other sites in terms of who is the most targeted for a given keyword cluster.',
//       className: 'page-insights right-box-shadow sticky-column',
//       left: 300.95,
//     },
//     {
//       name: 'Organic Performance',
//       colSpan: 4,
//       isHide: isCNP,
//       // info: 'These are all of your Google Search Console metrics from the past 30 days grouped by the Keyword Clusters mapped to this page.',
//       className: 'organic-performance right-box-shadow',
//     },
//     {
//       name: 'Search Volume and More',
//       colSpan: 3,
//       // info: 'Group of Extended Performance scores',
//       className: 'extended-performance right-box-shadow',
//     },
//     {
//       name: 'Paid Performance',
//       colSpan: 4,
//       isHide: isCNP,
//       // info: 'These are all of your Google Search Console metrics from the past 30 days grouped by the Keyword Clusters mapped to this page.',
//       className: 'paid-performance',
//     },
//   ];

//   const subHeading = {
//     keywordCluster: {
//       name: INTERACTIVE_TBL_HEADERS.KEYWORD_CLUSTER,
//       followedBy: [INTERACTIVE_TBL_HEADERS.CLUSTER_COUNT],
//       showStar: true,
//       className: 'keyword-cluster sticky-column right-box-shadow ',
//       isSort: true,
//       left: 75.46,
//     },
//     // NoOfKeywords: {
//     //   name: INTERACTIVE_TBL_HEADERS.No_OF_KEYWORDS,
//     //   className: 'no-of-keywords right-box-shadow sticky-column',
//     //   isSort: true,
//     //   showNewBadge: true,
//     //   left: 239.71,
//     // },
//     keywordImportance: {
//       name: INTERACTIVE_TBL_HEADERS.KEYWORD_IMPORTANCE,
//       isSort: true,
//       showLineProgress: true,
//       className: 'keyword-importance sticky-column ',
//       left: 300.95,
//     },
//     IntentEmphasis: {
//       name: INTERACTIVE_TBL_HEADERS.KEYWORD_RELEVANCE_SCORE,
//       isSort: true,
//       showSignal: true,
//       deltaScore: INTERACTIVE_TBL_HEADERS.INTENT_EMPHASIS_DELTA,
//       projectedScore: 'Projected',
//       className: 'keyword-relevance sticky-column',
//       showCustomRow: getCurrentAndProjectedHtml,
//       customRowParams: [
//         { dataKey: '_current', passKey: 'current' },
//         { dataKey: '_projected', passKey: 'projected' },
//       ],
//       left: 430.36,
//     },
//     contentQualityScore: {
//       name: INTERACTIVE_TBL_HEADERS.CONTENT_QUALITY_SCORE,
//       isSort: true,
//       className: 'content-quality sticky-column right-box-shadow',
//       // left: 545.4,
//       left: 581.03,
//     },
//     // improveSection: {
//     //   name: INTERACTIVE_TBL_HEADERS.IMPROVE_SECTION,
//     //   className: 'improve-section sticky-column box-shadow-effect',
//     //   // left: 678.06,
//     //   left: 714.7,
//     //   hideLabel: true,
//     // },
//     avgOrgPosition: {
//       name: INTERACTIVE_TBL_HEADERS.AVERAGE_ORGANIC_POSITION,
//       isSort: true,
//       formatValue: { ...formatValue },
//       className: 'average-organic-position',
//       isHide: isCNP,
//     },
//     orgImpressions: {
//       name: INTERACTIVE_TBL_HEADERS.ORG_IMPRESSIONS,
//       isSort: true,
//       className: 'organic-impressions',
//       isHide: isCNP,
//     },
//     orgClicks: {
//       name: INTERACTIVE_TBL_HEADERS.ORG_CLICKS,
//       isSort: true,
//       className: 'organic-clicks',
//       isHide: isCNP,
//     },
//     ctr: {
//       name: INTERACTIVE_TBL_HEADERS.CTR,
//       isSort: true,
//       className: 'ctr-section right-box-shadow',
//       isHide: isCNP,
//     },
//     avgCPC: {
//       isHide: false,
//       formatValue: { ...formatValue, decimal: 2, prefix: '$' },
//       name: INTERACTIVE_TBL_HEADERS.EXTENDED_AVERAGE_CPC,
//       isSort: true,
//       className: 'average-cpc',
//     },
//     avgSearchValue: {
//       isHide: false,
//       name: INTERACTIVE_TBL_HEADERS.EXTENDED_AVERAGE_SEARCH_VOLUME,
//       isSort: true,
//       className: 'extended-average-search-volume',
//     },
//     keywordDifficulty: {
//       isHide: false,
//       name: INTERACTIVE_TBL_HEADERS.EXTENDED_KEYWORD_DIFFICULTY,
//       isSort: true,
//       className: 'extended-keyword-difficulty  right-box-shadow',
//       ShowKeywordDifficultyScoreCircal: true,
//     },
//     paidImpressions: {
//       name: INTERACTIVE_TBL_HEADERS.PAID_IMPRESSIONS,
//       isSort: true,
//       className: 'paid-impressions',
//       isHide: isCNP,
//     },
//     paidClicks: {
//       name: INTERACTIVE_TBL_HEADERS.PAID_CLICKS,
//       isSort: true,
//       className: 'paid-clicks',
//       isHide: isCNP,
//     },
//     cpc: {
//       name: INTERACTIVE_TBL_HEADERS.CPC,
//       isSort: true,
//       formatValue: { ...formatValue, decimal: 1, prefix: '$' },
//       className: 'cpc-section',
//       isHide: isCNP,
//     },
//     cpa: {
//       name: INTERACTIVE_TBL_HEADERS.CPA,
//       isSort: true,
//       formatValue: { ...formatValue, decimal: 1, prefix: '$' },
//       className: 'cpa-section',
//       isHide: isCNP,
//     },
//   };

//   Object.keys(subHeading).forEach((key) => {
//     if (subHeading[key].isHide) {
//       delete subHeading[key];
//     }
//   });
//   return {
//     mainHeading: mainHeading?.filter((mh) => !mh?.isHide),
//     subHeading,
//   };
// };

export const getInteractiveGridDetails = (isCNP) => {
  const mainHeading = [
    {
      name: 'Branded',
      showCustomContent: true,
      colSpan: 3,
      className: 'branded-header right-box-shadow sticky-column',
      left: 5.5,
      columnOrderForOrg: 1,
      columnOrderForPaid: 1,
    },
    {
      name: 'Page Insights',
      showCustomContent: false,
      colSpan: 3,
      // info: 'These are Quattr metrics that analyze your keyword clusters. Keyword Importance is first looking at the overall size of a given cluster taking into consideration impressions and number of keywords. Relevance Score measures how strong your content is optimized for that particular cluster. Relevance Rank looks at where you stand in relation to other sites in terms of who is the most targeted for a given keyword cluster.',
      className: 'page-insights right-box-shadow sticky-column',
      left: 300.95,
      columnOrderForOrg: 2,
      columnOrderForPaid: 2,
    },
    {
      name: 'Organic Performance',
      colSpan: 4,
      isHide: isCNP,
      // info: 'These are all of your Google Search Console metrics from the past 30 days grouped by the Keyword Clusters mapped to this page.',
      className: 'organic-performance right-box-shadow',
      columnOrderForOrg: 3,
      columnOrderForPaid: 5,
    },
    {
      name: 'Search Volume and More',
      colSpan: 3,
      // info: 'Group of Extended Performance scores',
      className: 'extended-performance right-box-shadow',
      columnOrderForOrg: 4,
      columnOrderForPaid: 4,
    },
    {
      name: 'Paid Performance',
      colSpan: 4,
      isHide: isCNP,
      // info: 'These are all of your Google Search Console metrics from the past 30 days grouped by the Keyword Clusters mapped to this page.',
      className: 'paid-performance right-box-shadow',
      columnOrderForOrg: 5,
      columnOrderForPaid: 3,
    },
  ];

  const subHeading = {
    keywordCluster: {
      name: INTERACTIVE_TBL_HEADERS.KEYWORD_CLUSTER,
      followedBy: [INTERACTIVE_TBL_HEADERS.CLUSTER_COUNT],
      showStar: true,
      className: 'keyword-cluster sticky-column right-box-shadow ',
      isSort: true,
      left: 75.46,
      columnOrderForOrg: 1,
      columnOrderForPaid: 1,
    },
    // NoOfKeywords: {
    //   name: INTERACTIVE_TBL_HEADERS.No_OF_KEYWORDS,
    //   className: 'no-of-keywords right-box-shadow sticky-column',
    //   isSort: true,
    //   showNewBadge: true,
    //   left: 239.71,
    // },
    keywordImportance: {
      name: INTERACTIVE_TBL_HEADERS.KEYWORD_IMPORTANCE,
      isSort: true,
      showLineProgress: true,
      className: 'keyword-importance sticky-column ',
      left: 300.95,
      columnOrderForOrg: 2,
      columnOrderForPaid: 2,
    },
    IntentEmphasis: {
      name: INTERACTIVE_TBL_HEADERS.KEYWORD_RELEVANCE_SCORE,
      isSort: true,
      showSignal: true,
      deltaScore: INTERACTIVE_TBL_HEADERS.INTENT_EMPHASIS_DELTA,
      projectedScore: 'Projected',
      className: 'keyword-relevance sticky-column',
      showCustomRow: getCurrentAndProjectedHtml,
      customRowParams: [
        { dataKey: '_current', passKey: 'current' },
        { dataKey: '_projected', passKey: 'projected' },
      ],
      left: 430.36,
      columnOrderForOrg: 3,
      columnOrderForPaid: 3,
    },
    contentQualityScore: {
      name: INTERACTIVE_TBL_HEADERS.CONTENT_QUALITY_SCORE,
      isSort: true,
      className: 'content-quality sticky-column right-box-shadow',
      // left: 545.4,
      left: 581.03,
      columnOrderForOrg: 4,
      columnOrderForPaid: 4,
    },
    // improveSection: {
    //   name: INTERACTIVE_TBL_HEADERS.IMPROVE_SECTION,
    //   className: 'improve-section sticky-column box-shadow-effect',
    //   // left: 678.06,
    //   left: 714.7,
    //   hideLabel: true,
    // },
    avgOrgPosition: {
      name: INTERACTIVE_TBL_HEADERS.AVERAGE_ORGANIC_POSITION,
      isSort: true,
      formatValue: { ...formatValue },
      className: 'average-organic-position',
      isHide: isCNP,
      columnOrderForOrg: 5,
      columnOrderForPaid: 12,
    },
    orgImpressions: {
      name: INTERACTIVE_TBL_HEADERS.ORG_IMPRESSIONS,
      isSort: true,
      className: 'organic-impressions',
      isHide: isCNP,
      columnOrderForOrg: 6,
      columnOrderForPaid: 13,
    },
    orgClicks: {
      name: INTERACTIVE_TBL_HEADERS.ORG_CLICKS,
      isSort: true,
      className: 'organic-clicks',
      isHide: isCNP,
      columnOrderForOrg: 7,
      columnOrderForPaid: 14,
    },
    ctr: {
      name: INTERACTIVE_TBL_HEADERS.CTR,
      isSort: true,
      className: 'ctr-section right-box-shadow',
      isHide: isCNP,
      columnOrderForOrg: 8,
      columnOrderForPaid: 15,
    },
    avgCPC: {
      isHide: false,
      formatValue: { ...formatValue, decimal: 2, prefix: '$' },
      name: INTERACTIVE_TBL_HEADERS.EXTENDED_AVERAGE_CPC,
      isSort: true,
      className: 'average-cpc',
      columnOrderForOrg: 9,
      columnOrderForPaid: 9,
    },
    avgSearchValue: {
      isHide: false,
      name: INTERACTIVE_TBL_HEADERS.EXTENDED_AVERAGE_SEARCH_VOLUME,
      isSort: true,
      className: 'extended-average-search-volume',
      columnOrderForOrg: 10,
      columnOrderForPaid: 10,
    },
    keywordDifficulty: {
      isHide: false,
      name: INTERACTIVE_TBL_HEADERS.EXTENDED_KEYWORD_DIFFICULTY,
      isSort: true,
      className: 'extended-keyword-difficulty  right-box-shadow',
      ShowKeywordDifficultyScoreCircal: true,
      columnOrderForOrg: 11,
      columnOrderForPaid: 11,
    },
    paidImpressions: {
      name: INTERACTIVE_TBL_HEADERS.PAID_IMPRESSIONS,
      isSort: true,
      className: 'paid-impressions',
      isHide: isCNP,
      columnOrderForOrg: 12,
      columnOrderForPaid: 5,
    },
    paidClicks: {
      name: INTERACTIVE_TBL_HEADERS.PAID_CLICKS,
      isSort: true,
      className: 'paid-clicks',
      isHide: isCNP,
      columnOrderForOrg: 13,
      columnOrderForPaid: 6,
    },
    cpc: {
      name: INTERACTIVE_TBL_HEADERS.CPC,
      isSort: true,
      formatValue: { ...formatValue, decimal: 1, prefix: '$' },
      className: 'cpc-section',
      isHide: isCNP,
      columnOrderForOrg: 14,
      columnOrderForPaid: 7,
    },
    cpa: {
      name: INTERACTIVE_TBL_HEADERS.CPA,
      isSort: true,
      formatValue: { ...formatValue, decimal: 1, prefix: '$' },
      className: 'cpa-section right-box-shadow',
      isHide: isCNP,
      columnOrderForOrg: 15,
      columnOrderForPaid: 8,
    },
  };

  Object.keys(subHeading).forEach((key) => {
    if (subHeading[key].isHide) {
      delete subHeading[key];
    }
  });
  return {
    mainHeading: mainHeading?.filter((mh) => !mh?.isHide),
    subHeading,
  };
};

export const getScoreKeyForTab = (tab) => {
  // eslint-disable-next-line default-case
  switch (tab) {
    case 'Meta':
      return 'meta';
    case 'Headings':
      return 'headings';
    case 'Links':
      return 'links';
    case 'Body':
      return 'body';
    case 'Images':
      return 'images';
    case 'Structured Data':
      return 'structured data';
    case 'Topic Discovery':
      return 'topic discovery';
    case 'Overall':
      return 'overall';
  }
};
export const DEFAULT_TABS_DATA = {
  META: [],
  HEADINGS: [],
  LINKS: [],
  IMAGES: [],
  'STRUCTURED DATA': [],
  BODY: [],
};
export const KEYWORD_DATA_SOURCE = {
  //Purely Paid recommendations
  paidRecommendation: {
    improvementText: {
      text: 'Primarily Paid',
      isHide: false,
      className: '',
    },
    improvementInfo: {
      // availableImpClicks: 'Increase organic impression and organic clicks',
      // availableImp: 'Increase organic impression',
      // availableClicks: 'Increase organic clicks',
      availableImpClicks:
        'Paid impressions and clicks for these keywords are at least twice the organic impressions and clicks. This means there is significant room to grow organic clicks and impressions for these keywords.',
      availableImp:
        'Paid impressions for these keywords are at least twice the organic impressions. This means there is significant room to grow organic impressions for these keywords.',
      availableClicks:
        'Paid clicks for these keywords are at least twice the organic clicks. This means there is significant room to grow organic clicks for these keywords.',
      isHide: false,
      className: '',
    },
  },
  //Purely Organic recommendations
  organicRecommendation: {
    improvementText: {
      text: 'Primarily Organic',
      isHide: false,
      className: '',
    },
    improvementInfo: {
      // availableImpClicks: 'Increase paid impression and paid clicks',
      // availableImp: 'Increase paid impression',
      // availableClicks: 'Increase paid clicks',
      availableImpClicks:
        'Organic impressions and clicks for these keywords are at least twice the paid impressions and clicks. This means there is significant room to grow paid clicks and impressions for these keywords.',
      availableImp:
        'Organic impressions for these keywords are at least twice the paid impressions. This means there is significant room to grow paid impressions for these keywords.',
      availableClicks:
        'Organic clicks for these keywords are at least twice the paid clicks. This means there is significant room to grow paid clicks for these keywords.',
      isHide: false,
      className: '',
    },
  },
};

export const PAGE_SOURCE = {
  ORG: 'ORG',
  PAID: 'PAID',
};
export const DEFAULT_CUSTOMER_MS_DATA = {
  market_share: null,
  score: null,
  change: null,
};
export const DEFAULT_TOP_GSC_DFS_ROW_LIMIT = 15;
export const CR_EDITOR_BTN_LOADER = {
  SAVE: 'SAVE',
  DELETE: 'DELETE',
  NEW_SUGGESTION: 'NEW_SUGGESTION',
};
export const CONTENT_QUALITY_TBL = {
  TOPIC_IMPORTANCE: 'Topic Importance',
  COMPETITOR_PREVALENCE: 'Competitor Prevalence',
  TOPIC: 'Topic',
  CUSTOMER: 'Customer',
  COMPETITORS: 'Competitors',
  HEADINGS_COUNT: 'Headings count',
  TOPIC_ID: 'Topic Id',
  LOGOURLS: 'Logourls',
};

export const PROMPT_FOR_CHOICES = {
  'OPTIMIZE_CONTENT.IMPROVE_CONTENT_H1': 'OPTIMIZE_CONTENT.IMPROVE_CONTENT_H1_CHOICES_WITH_PAGE_CONTEXT',
  'OPTIMIZE_CONTENT.IMPROVE_CONTENT_TITLE': 'OPTIMIZE_CONTENT.IMPROVE_CONTENT_TITLE_CHOICES_WITH_PAGE_CONTEXT',
  'OPTIMIZE_CONTENT.IMPROVE_CONTENT_META': 'OPTIMIZE_CONTENT.IMPROVE_CONTENT_META_CHOICES_WITH_PAGE_CONTEXT',
  'OPTIMIZE_CONTENT.IMPROVE_CONTENT': 'OPTIMIZE_CONTENT.IMPROVE_CONTENT_CHOICES_WITH_PAGE_CONTEXT',
  'OPTIMIZE_CONTENT.IMPROVE_ANCHOR_TEXT': 'OPTIMIZE_CONTENT.IMPROVE_ANCHOR_TEXT_CHOICES_WITH_PAGE_CONTEXT',
  'OPTIMIZE_CONTENT.IMPROVE_IMAGE_ALT_TEXT': 'OPTIMIZE_CONTENT.IMPROVE_IMAGE_ALT_TEXT_CHOICES_WITH_PAGE_CONTEXT',
};
export const CONTENT_QUALITY_GRID_DETAILS = {
  mainHeading: [
    { name: '', group: 3, className: 'header-group' }, // Name empty to skip some Num of columns for grouping
    {
      name: 'Number of Sentences',
      group: 2,
      className: 'header-group',
      // info: 'This section shows how much content is written about a given topic with the number of sentences. You can compare how much you have, if any, and how much the competition has.',
    },
    { name: '', group: 1 }, // Name empty to skip some Num of columns for grouping
  ],
  subHeading: {
    topicImportance: {
      name: CONTENT_QUALITY_TBL.TOPIC_IMPORTANCE,
      isSort: true,
      showLineProgress: true,
      className: 'topicImportance',
    },
    compPrevalence: {
      name: CONTENT_QUALITY_TBL.COMPETITOR_PREVALENCE,
      isSort: true,
      className: 'comprevalence',
    },
    topicId: {
      name: CONTENT_QUALITY_TBL.TOPIC_ID,
      isHide: true,
    },
    topic: {
      name: CONTENT_QUALITY_TBL.TOPIC,
      followedBy: [CONTENT_QUALITY_TBL.HEADINGS_COUNT],
      showLogos: true,
      isSort: true,
      className: 'topic capitalize-content',
      showUpdatedInfo: true,
    },
    customer: {
      name: CONTENT_QUALITY_TBL.CUSTOMER,
      isSort: true,
      className: 'customer',
    },
    competitors: {
      name: CONTENT_QUALITY_TBL.COMPETITORS,
      isSort: true,
      className: 'competitors',
    },
    headingsCount: {
      isHide: true,
      name: CONTENT_QUALITY_TBL.HEADINGS_COUNT,
    },
    logoUrls: {
      isHide: true,
      name: CONTENT_QUALITY_TBL.LOGOURLS,
    },
    isAction: {
      name: 'Action',
      showActionAlways: true,
      // conditionColumn: CONTENT_QUALITY_TBL.TOPIC_IMPORTANCE,
      className: ' actions',
      title: 'Improve Content',
    },
  },
};
export const IMPROVE_HEADINGS_SUBTABLE = {
  HEADING_TYPE: 'Heading Type',
  USER: 'User',
  HEADING: 'Heading',
  NO_OF_SENTENSES: 'Number of Sentences',
  IMAGE_URL: 'imageUrl',
  CONTENT_QUALITY_SCORE: 'Content quality score',
  HTML_ID: 'Html Id',
  IS_CUSTOMER: 'Is Customer',
};
export const IMPROVE_HEADING_SUBTABLE_GRID_DETAILS = {
  subHeading: {
    headingType: {
      name: IMPROVE_HEADINGS_SUBTABLE.HEADING_TYPE,
      isSort: true,
      className: 'heading-type',
    },
    user: {
      name: IMPROVE_HEADINGS_SUBTABLE.USER,
      isSort: true,
      showImage: true,
      className: 'user capitalize-content',
    },
    heading: {
      name: IMPROVE_HEADINGS_SUBTABLE.HEADING,
      isSort: true,
      className: 'heading capitalize-content',
      showUpdatedInfo: true,
    },
    noOfSentenses: {
      name: IMPROVE_HEADINGS_SUBTABLE.NO_OF_SENTENSES,
      isSort: true,
      className: 'no-of-sentenses',
    },
    imageUrl: {
      name: IMPROVE_HEADINGS_SUBTABLE.IMAGE_URL,
      isSort: false,
      isHide: true,
    },
    contentQualityScore: {
      isHide: true,
      name: IMPROVE_HEADINGS_SUBTABLE.CONTENT_QUALITY_SCORE,
    },
    isAction: {
      name: 'Action',
      conditionColumn: IMPROVE_HEADINGS_SUBTABLE.HEADING,
      title: 'Improve Headings',
    },
    htmlId: {
      isHide: true,
      name: IMPROVE_HEADINGS_SUBTABLE.HTML_ID,
    },
    isCustomer: {
      isHide: true,
      name: IMPROVE_HEADINGS_SUBTABLE.IS_CUSTOMER,
    },
  },
};
export const IMPROVE_KEYWORD_SUBTABLE = {
  KEYWORD_CLUSTER: 'Keyword Cluster',
  KEYWORD_TYPE: '',
  KEYWORD_IMPORTANCE: 'Keyword Importance',
  INTENT_EMPHASIS: 'Relevance Score',
  AVERAGE_ORGANIC_POSITION: 'Average Organic Position',
  IMPRESSION_CLICKS_ORG: 'Impression & Clicks [Organic]',
  CTR: 'CTR',
  EMPHASIS_RANK: 'Relevance Rank',
  ORG_CLICKS: 'Org Clicks',
  INTENT_EMPHASIS_DELTA: 'Intent Relevance Delta',
  EMPHASIS_RANK_OLD: 'Relevance Rank Old',
};
export const IMPROVE_KEYWORD_SUBTABLE_GRID_DETAILS = {
  subHeading: {
    keywordCluster: {
      name: IMPROVE_KEYWORD_SUBTABLE.KEYWORD_CLUSTER,
      showStar: true,
      className: 'intent-alignment-improve-keyword capitalize-content ',
      isSort: true,
    },
    // keywordType: {
    //   name: IMPROVE_KEYWORD_SUBTABLE.KEYWORD_TYPE,
    //   showStar: true,
    //   isHidden : true,
    //   className: 'intent-alignment-keyword-type capitalize-content',
    //   isSort: false,
    // },
    keywordImportance: {
      name: IMPROVE_KEYWORD_SUBTABLE.KEYWORD_IMPORTANCE,
      isSort: true,
      showLineProgress: true,
      className: 'intent-alignment-importance',
    },
    intentEmphasis: {
      name: IMPROVE_KEYWORD_SUBTABLE.INTENT_EMPHASIS,
      isSort: true,
      showSignal: true,
      deltaScore: IMPROVE_KEYWORD_SUBTABLE.INTENT_EMPHASIS_DELTA,
      className: 'intent-alignment-emphasis',
    },
    emphasisRank: {
      name: INTENT_ALIGNMENT_TBL.EMPHASIS_RANK,
      showProjectedRank: true,
      oldRank: INTENT_ALIGNMENT_TBL.EMPHASIS_RANK_OLD,
      isSort: true,
      className: 'intent-alignment-emp-rank',
    },
    avgOrgPosition: {
      name: IMPROVE_KEYWORD_SUBTABLE.AVERAGE_ORGANIC_POSITION,
      isSort: true,
      formatValue: { ...formatValue },
      className: 'intent-alignment-avg-position',
      subRowDefault: '--',
    },
    ctr: {
      name: IMPROVE_KEYWORD_SUBTABLE.CTR,
      isSort: true,
      formatValue: {
        ...formatValue,
        decimal: 1,
        suffix: '%',
        inToPercentage: 100,
      },
      className: 'intent-alignment-ctr',
      subRowDefault: '--',
    },
    orgClick: {
      isHide: true,
      name: IMPROVE_KEYWORD_SUBTABLE.ORG_CLICKS,
    },
    intentEmphasisDelta: {
      isHide: true,
      name: IMPROVE_KEYWORD_SUBTABLE.INTENT_EMPHASIS_DELTA,
    },
    emphasisRankOld: {
      isHide: true,
      name: IMPROVE_KEYWORD_SUBTABLE.EMPHASIS_RANK_OLD,
    },
    // isAction: {
    //   name: "Action",
    //   conditionColumn: IMPROVE_KEYWORD_SUBTABLE.INTENT_EMPHASIS,
    //   title: "Improve"
    // },
  },
};
export const TOPIC_IMPROVEMENT_TBL = {
  TOPIC_IMPORTANCE: 'Topic Importance',
  COMPETITOR_PREVALENCE: 'Competitor Prevalence',
  TOPIC: 'Topic',
  CUSTOMER: 'Customer',
  COMPETITORS: 'Competitors',
  HEADINGS_COUNT: 'Headings count',
  TOPIC_ID: 'Topic Id',
};
export const TOPIC_IMPROVEMENT_GRID_DETAILS = {
  mainHeading: [
    { name: '', group: 3, className: 'header-group' }, // Name empty to skip some Num of columns for grouping
    {
      name: 'Number of Sentences',
      group: 2,
      className: 'header-group',
      // info: 'This section shows how much content is written about a given topic with the number of sentences. You can compare how much you have, if any, and how much the competition has.',
    },
    { name: '', group: 1 }, // Name empty to skip some Num of columns for grouping
  ],
  subHeading: {
    topicImportance: {
      name: TOPIC_IMPROVEMENT_TBL.TOPIC_IMPORTANCE,
      isSort: false,
      showLineProgress: true,
      className: 'topicImportance',
    },
    compPrevalence: {
      name: TOPIC_IMPROVEMENT_TBL.COMPETITOR_PREVALENCE,
      isSort: false,
      className: 'comprevalence',
    },
    topic: {
      name: TOPIC_IMPROVEMENT_TBL.TOPIC,
      followedBy: [TOPIC_IMPROVEMENT_TBL.HEADINGS_COUNT],
      isSort: false,
      className: 'topic capitalize-content',
      showChangeTopicButton: true,
      showUpdatedInfo: true,
    },
    topicId: {
      name: TOPIC_IMPROVEMENT_TBL.TOPIC_ID,
      isHide: true,
    },
    customer: {
      name: TOPIC_IMPROVEMENT_TBL.CUSTOMER,
      isSort: false,
      className: 'customer',
    },
    competitors: {
      name: TOPIC_IMPROVEMENT_TBL.COMPETITORS,
      isSort: false,
      className: 'competitors',
    },
    headingsCount: {
      isHide: true,
      name: TOPIC_IMPROVEMENT_TBL.HEADINGS_COUNT,
    },
  },
};
// for over-all tabs
export const CONTENT_ELEMENT_LIST1 = ['Headings', 'Meta', 'Images', 'Body', 'Links', 'Structured Data'];
export const CONTENT_ELEMENT_LIST = {
  meta: { name: 'Meta', label: 'Meta' },
  headings: { name: 'Headings', label: 'Headings' },
  links: { name: 'Links', label: 'Anchor Text (Links)' },
  images: { name: 'Images', label: 'Alt Text (Images)' },
  body: { name: 'Body', label: 'Body' },
  'structured data': { name: 'Structured Data', label: 'Structured Data' },
};

export const TAG_GROUPS = Object.values(CONTENT_ELEMENT_LIST).map((ce) => {
  return { text: `${ce?.label}`, value: `${ce?.name}` };
});

export const TOPIC_KEYWORD_DROPDOWN = {
  KEYWORD: 'Keyword',
  KEYWORD_IMPORTANCE: 'Keyword Importance',
  IS_OVERALL: 'isOverall',
};
export const OVERALL_ENTRY = 'Overall';
export const KEYWORDS_DROPDOWN = {
  mainHeading: [],
  subHeading: {
    keywordCluster: {
      name: INTENT_ALIGNMENT_TBL.KEYWORD_CLUSTER,
      showStar: true,
      className: 'intent-alignment-keyword',
    },
    keywordImportance: {
      name: INTENT_ALIGNMENT_TBL.KEYWORD_IMPORTANCE,
      showLineProgress: true,
      className: 'intent-alignment-importance',
    },
    emphasisRank: {
      name: INTENT_ALIGNMENT_TBL.EMPHASIS_RANK,
      showProjectedRank: true,
      oldRank: INTENT_ALIGNMENT_TBL.EMPHASIS_RANK_OLD,
      className: 'intent-alignment-emp-rank',
    },
    emphasisRankOld: {
      isHide: true,
      name: INTENT_ALIGNMENT_TBL.EMPHASIS_RANK_OLD,
    },
    rowClick: {
      isHide: true,
    },
  },
};
export const DEFAULT_REVIEW_CONTENT_QUALITY_DATA = { topicsData: [], contentQuality: {}, projected: null };
export const DEFAULT_PAGE_AND_KEYWORD_TOPICS = { keywordsLevelTopicsData: {}, pageLevelTopicsData: [] };
export const ALLOWCQFORTAGS = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'p'];
export const POTENTIAL_KEYWORDS_FIELDS = {
  //KEYWORD_CHECKBOX:'Keyword Checkbox',
  KEYWORD_CLUSTER: 'Keyword Cluster',
  KEYWORD_TYPE: '',
  NO_OF_KEYWORDS: 'No Of Keywords',
  KEYWORDS_OPPORTUNITY_SOCRE: 'Keyword Opportunity',
  SUITABILITY_RATING: 'Suitability Rating',
  COMPETITORS_RANKING: 'Competitors Ranking',
  AVERAGE_SEARCH_VOLUME: 'Average Search Volume',
  AVERAGE_CPC: 'Average CPC',
  KEYWORD_DIFFICULTY: 'Keyword Difficulty',
};
export const POTENTIAL_KEYWORDS_FIELDS_GRID = {
  mainHeading: [],
  subHeading: {
    // keywordCheckbox: {
    //   name: POTENTIAL_KEYWORDS_FIELDS.KEYWORD_CHECKBOX,
    //   className: 'potential-keyword-tbl-keyword-checkbox',
    //   showCustomComponent: true,
    //   isSort: false,
    //   isHideHeaderName: true,
    // },
    keywordCluster: {
      name: POTENTIAL_KEYWORDS_FIELDS.KEYWORD_CLUSTER,
      className: 'potential-keyword-tbl-keyword-cluster',
      showCustomComponent: true,
      isSubComponent: true,
      isSort: true,
    },
    // keywordType: {
    //   name: POTENTIAL_KEYWORDS_FIELDS.KEYWORD_TYPE,
    //   className: 'potential-keyword-tbl-kywords-type',
    //   showCustomComponent: true,
    //   isHide : false,
    //   isSort: false,
    // },
    noOfKeywords: {
      name: POTENTIAL_KEYWORDS_FIELDS.NO_OF_KEYWORDS,
      className: 'potential-keyword-tbl-no-of-keywords',
      showCustomComponent: true,
      isSort: true,
    },
    isAction: {
      name: 'Action',
      title: 'Include in Targeted',
      className: 'potential-keyword-tbl-action-column',
      isHide: false,
    },
    kos: {
      name: POTENTIAL_KEYWORDS_FIELDS.KEYWORDS_OPPORTUNITY_SOCRE,
      className: 'potential-keyword-tbl-keywords-opportunity-socre',
      showCustomComponent: true,
      isSort: true,
    },
    suitabilityRating: {
      name: POTENTIAL_KEYWORDS_FIELDS.SUITABILITY_RATING,
      className: 'potential-keyword-tbl-suitability-rating',
      showCustomComponent: true,
      isSort: true,
    },
    competitorsRanking: {
      name: POTENTIAL_KEYWORDS_FIELDS.COMPETITORS_RANKING,
      className: 'potential-keyword-tbl-competitors-ranking',
      showCustomComponent: true,
    },
    averageSearchVolume: {
      name: POTENTIAL_KEYWORDS_FIELDS.AVERAGE_SEARCH_VOLUME,
      className: 'potential-keyword-tbl-average-search-volume',
      showCustomComponent: true,
      isSort: true,
    },
    averageCpc: {
      name: POTENTIAL_KEYWORDS_FIELDS.AVERAGE_CPC,
      className: 'potential-keyword-tbl-average-cpc',
      showCustomComponent: true,
      isSort: true,
    },
    keywordDifficulty: {
      name: POTENTIAL_KEYWORDS_FIELDS.KEYWORD_DIFFICULTY,
      className: 'potential-keyword-tbl-keyword-difficulty',
      showCustomComponent: true,
      isSort: true,
    },
  },
};
export const TAGS_GROUP_NAME = {
  META: 'Meta',
  HEADINGS: 'Headings',
  IMAGES: 'Images',
  LINKS: 'LINKS',
  BODY: 'BODY',
  STRUCTURE_DATA: 'Structured Data',
};
export const ALL_KEYWORDS_DROPDOWN_TAGS = {
  meta: [
    { text: 'H1 - Heading 1', value: 'H1' },
    { text: 'Title', value: 'Title' },
    { text: 'Meta Description', value: 'Meta Description' },
  ],
  headings: [
    { text: 'H2 - Heading 2', value: 'H2' },
    { text: 'H3 - Heading 3', value: 'H3' },
    { text: 'H4 - Heading 4', value: 'H4' },
    { text: 'H5 - Heading 5', value: 'H5' },
    { text: 'H6 - Heading 6', value: 'H6' },
  ],
  body: [
    { text: 'P - Paragraph', value: 'p' },
    { text: 'Pre - Preformatted Text', value: 'pre' },
    { text: 'Label', value: 'label' },
    { text: 'LI - Ordered list', value: 'li' },
    { text: 'SPAN - Span', value: 'span' },
  ],
  links: [{ text: 'Anchor Tag - <a>', value: 'a' }],
};
// only for keywords,  [topics screen we are showings for all]
export const SHOW_CREATE_SIMILAR_FOR_TAG = [
  'TITLE',
  'META DESCRIPTION',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'P',
  'PRE',
  'LABEL',
  'OL',
  'UL',
  'LI',
  'SPAN',
];
export const HEADING_TAGS = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
export const HEADING_CHILD_TAGS = ['P', 'PRE', 'LABEL', 'OL', 'UL', 'LI', 'SPAN'];
export const ALLOW_FOR_CQ_PAYLOAD = [...HEADING_TAGS, ...HEADING_CHILD_TAGS];
export const PIPELINE_STATUS = {
  NOT_TRIGGER: 'NOT TRIGGER',
  START: 'START',
  FAILED: 'FAILED',
  SCCUESS: 'SUCCESS',
};
export const CR_JOB_TYPE = {
  CLUSTER_INCLUSION: 'cluster_inclusion',
  ADD_NEW_PAGE: 'add_new_page',
};

export const IL_INCOMING_LIST_FILEDS = {
  ID: 'ID',
  URL: 'Source URLs',
  ANCHOR_TEXT: 'Anchor Text',
  KEYWORD: 'Keyword',
  TOTAL_CLICKS: 'Source URL Clicks',
  TOTAL_IMPRESSIONS: 'Source URL Impressions',
};

export const IL_INCOMING_LIST_FILEDS_GRID = {
  mainHeading: [],
  subHeading: {
    // id: {
    //   name: IL_INCOMING_LIST_FILEDS.ID,
    //   className: 'tbl-il-incoming-id',
    //   showCustomComponent: true,
    //   isSort: true,
    // },
    url: {
      name: IL_INCOMING_LIST_FILEDS.URL,
      className: 'tbl-il-incoming-url',
      showCustomComponent: true,
      isSort: true,
    },
    anchorText: {
      name: IL_INCOMING_LIST_FILEDS.ANCHOR_TEXT,
      className: 'tbl-il-incoming-anchor-text',
      showCustomComponent: true,
      isSort: true,
    },
    keyword: {
      name: IL_INCOMING_LIST_FILEDS.KEYWORD,
      className: 'tbl-il-incoming-keyword',
      showCustomComponent: true,
      isSort: true,
    },
    totalClicks: {
      name: IL_INCOMING_LIST_FILEDS.TOTAL_CLICKS,
      className: 'tbl-il-incoming-total-clicks',
      showCustomComponent: true,
      isSort: true,
    },
    totalImpressions: {
      name: IL_INCOMING_LIST_FILEDS.TOTAL_IMPRESSIONS,
      className: 'tbl-il-incoming-total-impressions',
      showCustomComponent: true,
      isSort: true,
    },
  },
};

export const IL_OUTGOING_LIST_FILEDS = {
  ID: 'ID',
  URL: 'Target URLs',
  ANCHOR_TEXT: 'Anchor Text',
  KEYWORD: 'Keyword',
  TARGET_CATEGORY: 'Target Category',
  TOTAL_CLICKS: 'Target URL Clicks',
  TOTAL_IMPRESSIONS: 'Target URL Impressions',
};

export const IL_OUTGOING_LIST_FILEDS_GRID = {
  mainHeading: [],
  subHeading: {
    // id: {
    //   name: IL_INCOMING_LIST_FILEDS.ID,
    //   className: 'tbl-il-incoming-id',
    //   showCustomComponent: true,
    //   isSort: true,
    // },
    url: {
      name: IL_OUTGOING_LIST_FILEDS.URL,
      className: 'tbl-il-outgoing-url',
      showCustomComponent: true,
      isSort: true,
    },
    category: {
      name: IL_OUTGOING_LIST_FILEDS.TARGET_CATEGORY,
      className: 'tbl-il-outgoing-category',
      showCustomComponent: true,
      isSort: true,
    },
    anchorText: {
      name: IL_OUTGOING_LIST_FILEDS.ANCHOR_TEXT,
      className: 'tbl-il-outgoing-anchor-text',
      showCustomComponent: true,
      isSort: true,
    },
    keyword: {
      name: IL_OUTGOING_LIST_FILEDS.KEYWORD,
      className: 'tbl-il-outgoing-keyword',
      showCustomComponent: true,
      isSort: true,
    },
    totalClicks: {
      name: IL_OUTGOING_LIST_FILEDS.TOTAL_CLICKS,
      className: 'tbl-il-outgoing-total-clicks',
      showCustomComponent: true,
      isSort: true,
    },
    totalImpressions: {
      name: IL_OUTGOING_LIST_FILEDS.TOTAL_IMPRESSIONS,
      className: 'tbl-il-outgoing-total-impressions',
      showCustomComponent: true,
      isSort: true,
    },
  },
};

export const DEFAULT_COUNTRY_LANGAUGE = {
  country: {
    name: 'United States of America',
    alpha_2: 'US',
    alpha_3: 'USA',
    location_code: '2840',
  },
  language: {
    language_code: 'en',
    location_code: '2124',
    name: 'English',
  },
};

export const CR_TAB_KEYS = {
  PAGE_WORKFLOW: 'page_workflow',
  PAGE_EDITOR: 'page_editor',
  PAGE_GIGA_AGENT: 'page_giga_agent',

  ALL_EDITOR: 'all_editor_old',
  ALL_KEYWORDS: 'all_keywords',
  ALL_TOPICS: 'all_topics',
  ALL_COMPETITORS: 'all_competitors',
  ALL_INTENAL_LINKING: 'all_intenal_linking',
  ALL_CONTENT_IDEAS: 'all_content_ideas',
  SUB_KEYWORDS_TABS: {
    TARGETED_CLUSTERS: 'targeted_clusters',
    GAP_KEYWORDS: 'gap_keywords',
    EXCLUDED_KEYWORDS: 'excluded_keywords',
  },
  // SUB_EDITOR_TABS: {
  //   ALL_EDITOR: 'all_editor',
  //   ALL_TOPICS: 'all_topics',
  //   META: 'all_meta',
  //   HEADINGS: 'all_headings',
  //   ANCHOR_TEXT: 'all_anchor_text',
  //   ALT_TEXT: 'all_alt_text',
  //   BODY: 'all_body',
  //   STRUCTURE_DATA: 'all_structured_data',
  // },
  SUB_EDITOR_TABS: {
    ALL_EDITOR: 'all_editor',
    ALL_TOPICS: 'all_topics',
    META: 'Meta',
    HEADINGS: 'Headings',
    ANCHOR_TEXT: 'Links',
    ALT_TEXT: 'Images',
    BODY: 'Body',
    STRUCTURE_DATA: 'Structured Data',
    EEAT: 'EEAT',
    PREVIEW: 'preview',
  },
};

export const CR_TAB_LABELS = {
  [CR_TAB_KEYS.PAGE_WORKFLOW]: 'Page Workflow',
  [CR_TAB_KEYS.PAGE_EDITOR]: 'Editor',
  [CR_TAB_KEYS.PAGE_GIGA_AGENT]: 'GIGA AI Agent',

  [CR_TAB_KEYS.ALL_KEYWORDS]: 'Keywords / Prompts',
  [CR_TAB_KEYS.ALL_COMPETITORS]: 'Competitors',
  [CR_TAB_KEYS.ALL_INTENAL_LINKING]: 'Internal Linking',
  [CR_TAB_KEYS.ALL_CONTENT_IDEAS]: 'Content Ideas',

  // Sub Keywords Tabs
  [CR_TAB_KEYS.SUB_KEYWORDS_TABS.TARGETED_CLUSTERS]: 'Targeted Clusters',
  [CR_TAB_KEYS.SUB_KEYWORDS_TABS.GAP_KEYWORDS]: 'Gap Keywords',
  [CR_TAB_KEYS.SUB_KEYWORDS_TABS.EXCLUDED_KEYWORDS]: 'Excluded Keywords',

  // Sub Editor Tabs
  [CR_TAB_KEYS.SUB_EDITOR_TABS.ALL_EDITOR]: 'Content Editor',
  [CR_TAB_KEYS.SUB_EDITOR_TABS.ALL_TOPICS]: 'Topics',
  [CR_TAB_KEYS.SUB_EDITOR_TABS.META]: 'Metadata',
  [CR_TAB_KEYS.SUB_EDITOR_TABS.HEADINGS]: 'Headings',
  [CR_TAB_KEYS.SUB_EDITOR_TABS.ANCHOR_TEXT]: 'Anchor Text',
  [CR_TAB_KEYS.SUB_EDITOR_TABS.ALT_TEXT]: 'Alt Text',
  [CR_TAB_KEYS.SUB_EDITOR_TABS.BODY]: 'Passages',
  [CR_TAB_KEYS.SUB_EDITOR_TABS.STRUCTURE_DATA]: 'Structured Data',
  [CR_TAB_KEYS.SUB_EDITOR_TABS.EEAT]: 'E-E-A-T',
  [CR_TAB_KEYS.SUB_EDITOR_TABS.PREVIEW]: 'Preview',
};

export const CREATE_NEW_PAGE_USING = {
  FROM_TARGET: 'FROM_TARGET',
  FROM_KEYWORD_GAP: 'FROM_KEYWORD_GAP',
  FROM_NEW: 'FROM_NEW',
  FROM_SEARCH_INTENTS: 'FROM_SEARCH_INTENTS',
  GROWTH_TRENDS: 'GROWTH_TRENDS',
};
export const PAGE_WORKFLOW_TABS_CONFIG = [
  {
    label: 'Keywords / Prompts',
    key: CR_TAB_KEYS.ALL_KEYWORDS,
    showTab: true,
  },
  {
    label: 'Competitors',
    key: CR_TAB_KEYS.ALL_COMPETITORS,
    showTab: true,
  },
  {
    label: 'Internal Links',
    key: CR_TAB_KEYS.ALL_INTENAL_LINKING,
    showTab: true,
  },
  {
    label: 'Content Ideas',
    key: CR_TAB_KEYS.ALL_CONTENT_IDEAS,
    showTab: true,
  },
];

export const PIPLINE_TRIGGER_FOR = {
  NEW: '', // new page, existing page with refresh icon, new page with dfs and gsc is true
  ONLY_KEYWORD_INCLUDEDS: 'ONLY_KEYWORD_INCLUDEDS', //15 === 19
  PIN_UNPIN_KEYWORD: 'PIN_UNPIN_KEYWORD', // when pin/unpin and keyword is added //16 === 20
  ONLY_PIN_UNPIN: 'ONLY_PIN_UNPIN', // when there is only pinned or unpinned is done, no any keywords added; //17 === 21
  CNP_ONLY_COUNTRY_LANGUAGE_CHANGED: 'CNP_ONLY_COUNTRY_LANGUAGE_CHANGED', // new page, existing page with refresh icon, new page with dfs and gsc is true
  CNP_COUNTRY_LANGUAGE_CHANGED_AND_KEYWORD_INCLUDEDS: 'CNP_COUNTRY_LANGUAGE_CHANGED_AND_KEYWORD_INCLUDEDS',
  CNP_COUNTRY_LANGUAGE_CHANGED_AND_PIN_UNPIN_KEYWORD: 'CNP_COUNTRY_LANGUAGE_CHANGED_AND_PIN_UNPIN_KEYWORD', // when pin/unpin and keyword is added
  CNP_COUNTRY_LANGUAGE_CHANGED_AND_ONLY_PIN_UNPIN: 'CNP_COUNTRY_LANGUAGE_CHANGED_AND_ONLY_PIN_UNPIN', // when there is only pinned or unpinned is done, no any keywords added;
};

export const CR_PIPELINE_TRIGGER_MESSAGE = {
  [PIPLINE_TRIGGER_FOR.ONLY_KEYWORD_INCLUDEDS]: {
    TITLE: 'Generate New Insights that align with changes',
    DESCRIPTION:
      'we need to regenerate relevance & topic recommendations. Click on Regenerate Insights to get updated SEO guidance for them.',
  },
  [PIPLINE_TRIGGER_FOR.ONLY_PIN_UNPIN]: {
    TITLE: 'Generate New Insights that align with competitor preferences',
    DESCRIPTION:
      'we need to regenerate relevance & topic recommendations. Click on Regenerate Insights to get updated SEO guidance for them.',
  },
  [PIPLINE_TRIGGER_FOR.CNP_ONLY_COUNTRY_LANGUAGE_CHANGED]: {
    TITLE: 'Generate New Insights that align with geotagging changes',
    DESCRIPTION:
      'we need to regenerate relevance & topic recommendations. Click on Regenerate Insights to get updated SEO guidance for them.',
  },
  COMBINATION: {
    // COMBINATION WITH ANYONE
    TITLE: 'Generate New Insights that align with changes',
    DESCRIPTION:
      'we need to regenerate relevance & topic recommendations. Click on Regenerate Insights to get updated SEO guidance for them.',
  },
  OPTIMIZED_PAGE: {
    // ADD NEW PAGE OR ADD TO OPTIMIZE flow
    TITLE: 'We found keywords for this page based on past performance in Google',
    DESCRIPTION: 'Click the generate insights button to submit this page for keyword and topic',
  },
  RUN_OPTIMIZED_PAGE: {
    // only after pipeline trigger, key should start with RUN_
    TITLE: 'Analyzing keyword trends and topic recommendations for this page',
    DESCRIPTION:
      'In case you made the changes, you will receive an email once the analysis & SEO guidance is ready for use.',
  },
  RUN_NORMAL: {
    // only after pipeline trigger, key should start with RUN_
    // TITLE: 'Analyzing keyword trends for this page',
    TITLE: 'Generating insights to help optimize the page',
    DESCRIPTION:
      'We are analyzing competitor pages and generating topic clusters, identifying keyword gaps & calculating scores. You can start optimizing right away,',
  },
};

export const CR_STEPS_PROGRESS = {
  RESEARCH_KEYWORDS: {
    LABEL: 'Research Keywords',
    VALUE: 'research_keywords',
    STEP: 1,
  },
  ANALYZE_SEARCH_RESULT: {
    LABEL: 'Analyze Search Results',
    VALUE: 'analyze_search_results',
    STEP: 2,
  },
  IMPROVE_CONTENT: {
    LABEL: 'Improve Content',
    CNP_LABEL: 'Write & Improve Content',
    VALUE: 'improve_content',
    STEP: 3,
  },
  PUBLISH_CHANGES: {
    LABEL: 'Export & Publish Changes',
    VALUE: 'publish_changes',
    STEP: 4,
  },
};

export const CR_STEP_PROGRESS_STATUS = {
  NULL_STATUS: null,
  IN_PROGRESS: 'in-progress',
  SUCCESS: 'success',
  FAILED: 'failed',
};

export const ANALYZE_COMP_SELECTION_OPTION = {
  RECOMMENDED: 'recommended',
  ADVANCED: 'advanced',
};

export const TRAFFIC_SOURCE_OPTIONS = {
  CLASSIC_GOOGLE_SEARCH: {
    value: 'classic_google_search',
    label: 'Classic Google Search',
    icon: 'https://www.google.com/s2/favicons?sz=64&domain=https://www.google.com',
    disabled: false,
    isDefault: true,
  },
  GOOGLE_AI_MODE: {
    value: 'google-ai-mode',
    label: 'Google AI Mode',
    icon: 'data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCI+PGc+PHJlY3QgZmlsbD0ibm9uZSIgaGVpZ2h0PSIyNCIgd2lkdGg9IjI0Ij48L3JlY3Q+PC9nPjxnPjxnPjxwYXRoIGZpbGw9ImJsYWNrIiBkPSJNMTcuNSAxMmMwLTMuMDQgMi40Ni01LjUgNS41LTUuNS0zLjA0IDAtNS41LTIuNDYtNS41LTUuNSAwIDMuMDQtMi40NiA1LjUtNS41IDUuNSAzLjA0IDAgNS41IDIuNDYgNS41IDUuNXoiPjwvcGF0aD48cGF0aCBmaWxsPSJibGFjayIgZD0iTTE1LjY1IDExLjU4Yy4xOC0uNS4yNy0xLjAzLjMxLTEuNThoLTJjLS4xIDEuMDMtLjUxIDEuOTMtMS4yNyAyLjY5LS44OC44Ny0xLjk0IDEuMzEtMy4xOSAxLjMxQzcuMDMgMTQgNSAxMi4wNyA1IDkuNSA1IDcuMDMgNi45MyA1IDkuNSA1Yy40NiAwIC44OS4wOCAxLjMuMmwxLjU2LTEuNTZDMTEuNSAzLjIyIDEwLjU1IDMgOS41IDMgNS44NSAzIDMgNS44NSAzIDkuNVM1Ljg1IDE2IDkuNSAxNmMuNTYgMCAyLjI2LS4wNiAzLjgtMS4zbDYuMyA2LjMgMS40LTEuNC02LjMtNi4zYy40LS41LjcyLTEuMDguOTUtMS43MnoiPjwvcGF0aD48L2c+PC9nPjwvc3ZnPg==',
    disabled: true,
    isDefault: false,
  },
  CHATGPT: {
    value: 'chatgpt',
    label: 'ChatGPT',
    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA8NJREFUaEPtWUtuGzEMpSYXyU2S3MH79AI13GXcAq2B1l3WcC9Q7+cOcW7ii9gqNCONKYmkKNleBMhs8hlJw0c+fmXgnT/mncsPHwCCBWeLb49wPH4f/jbmcfhp7R6MeXO/9tv1j1tY+2ILTIIHoWUpV9cGchGA2eeX10nbWvVau+///n7SLi+tawaQCe/o4p67u1W/+bkfLHM6jVQCGKnlHwNwsAC76R9dN+x1+0oCp++bAMzmS8dnLFSRGrP50gn3IArofaaGZtUAaoUn1peV7IB4S5YWtwCw6FBR84Lwq0gwax8YXypaVg3ACWMBng3Affh4v12T+yXBJXp4v3lNtC6CKAKoEaZmLUcNCgSnKHeGCKAQJiPNMGtX0HX72uhCgGCtwAIoxXislVrTD5ZyvEdhN7VIak3OCloODxqYzZeTA0cA4rDKaquWYvh70HVPlCUzAJL5FABI4TPBx3gfktxZ+YmQyT7y7BwALg+StF8LYBTA3APYZy/lED4Ha4biLwWCckA1gEz7uUZKFJq0pE14IpCxkh0zPlNDRRaIABAbNBagah9N4lNk7DKFokPaAOBgcj1ruFM1TlzinMIC7lMTzzEaf7b7ly8CzQ4684+KLGRY7syXfvNrI1ajVwDw1m/XeXRBXyWqUjpyjeX4uaxQ+QCO520UKhZfSEnOQXF5zYVgsXjknXgMd/H7uAOjOF4DICTHuLeQcgGhVDkPAMT1TmpW/x5ptRqAY1dN8EidOQeQdFtUDUKEvECHJgAeBJljhneM5dlqNCvkmBBGAalw4ti6TJ2VWShhBV3MLb4u4GT/RCGLAzHQ6vgJwGTlghxGE3peF0ASwoIkQq8qlQ5MltVboJpC+dQhzR8tJfOU5HwyawOQMIGmUIJ4aD6EqrHUjLjsHHphLmKxWT6NfCoARINSUf7G5QLYA27kqwEI5T0fhYQOi2kfwyAXlxGl5qZIocx3iEDCRKHYiZW5IDBJ6x8iAG0/wTf1KKxhDkehMR6pu0KOHKGTUUhollKf4poZlkJE8mDr8exjuPI8D3ij4W4qkNjMFKbZ8lwotkIViJoJRM1asR9QhMMiiBZhcAi1AAcDsNNOqNtHi+j6CAGPqTK+qBoAS2NEiq5FAIM/cCMQyQEahC+BbQYQNk4jwfJ9mKa1rL4kuRjABMRZxD3nKyRIR+9+7XgP4Ae85E2me3/BvZmKQmWmjCtKA2HynAuEF/OAVmhV5KIOq7hGkmS5qgXwh6Y5EK5kk5vMViXhfTcDcA3hNGd8ANBo6ZZr/gNE1HVe4YzKLAAAAABJRU5ErkJggg==',
    disabled: false,
    isDefault: false,
  },
  PERPLEXITY: {
    value: 'perplexity',
    label: 'Perplexity',
    icon: 'https://www.google.com/s2/favicons?sz=64&domain=https://www.perplexity.ai',
    disabled: false,
    isDefault: false,
  },
  GOOGLE_AI_OVERVIEW: {
    value: 'ai-overview',
    label: 'Google AI Overview',
    icon: 'data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iZldXbG1mIEp6SVNrZSIgaGVpZ2h0PSIyNCIgd2lkdGg9IjI0IiBhcmlhLWhpZGRlbj0idHJ1ZSIgdmlld0JveD0iMCAwIDQ3MSA0NzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbD0icmdiKDEyMiwgMTcyLCAyNTUpIiBkPSJNMjM1LjUgNDcxQzIzNS41IDQzOC40MjMgMjI5LjIyIDQwNy44MDcgMjE2LjY2IDM3OS4xNTVDMjA0LjQ5MiAzNTAuNTAzIDE4Ny44MTEgMzI1LjU3OSAxNjYuNjE2IDMwNC4zODRDMTQ1LjQyMSAyODMuMTg5IDEyMC40OTggMjY2LjUwOCA5MS44NDUgMjU0LjM0QzYzLjE5MjUgMjQxLjc4IDMyLjU3NzUgMjM1LjUgMCAyMzUuNUMzMi41Nzc1IDIzNS41IDYzLjE5MjUgMjI5LjQxNiA5MS44NDUgMjE3LjI0OUMxMjAuNDk4IDIwNC42ODkgMTQ1LjQyMSAxODcuODExIDE2Ni42MTYgMTY2LjYxNkMxODcuODExIDE0NS40MjEgMjA0LjQ5MiAxMjAuNDk3IDIxNi42NiA5MS44NDVDMjI5LjIyIDYzLjE5MjUgMjM1LjUgMzIuNTc3NSAyMzUuNSAwQzIzNS41IDMyLjU3NzUgMjQxLjU4NCA2My4xOTI1IDI1My43NTEgOTEuODQ1QzI2Ni4zMTEgMTIwLjQ5NyAyODMuMTg5IDE0NS40MjEgMzA0LjM4NCAxNjYuNjE2QzMyNS41NzkgMTg3LjgxMSAzNTAuNTAzIDIwNC42ODkgMzc5LjE1NSAyMTcuMjQ5QzQwNy44MDcgMjI5LjQxNiA0MzguNDIzIDIzNS41IDQ3MSAyMzUuNUM0MzguNDIzIDIzNS41IDQwNy44MDcgMjQxLjc4IDM3OS4xNTUgMjU0LjM0QzM1MC41MDMgMjY2LjUwOCAzMjUuNTc5IDI4My4xODkgMzA0LjM4NCAzMDQuMzg0QzI4My4xODkgMzI1LjU3OSAyNjYuMzExIDM1MC41MDMgMjUzLjc1MSAzNzkuMTU1QzI0MS41ODQgNDA3LjgwNyAyMzUuNSA0MzguNDIzIDIzNS41IDQ3MVoiPjwvcGF0aD4KPC9zdmc+',
    disabled: false,
    isDefault: false,
  },
  GEMINI: {
    value: 'gemini',
    label: 'Gemini',
    icon: 'https://www.google.com/s2/favicons?sz=64&domain=https://gemini.google.com',
    disabled: false,
    isDefault: false,
  },
  CLAUDE: {
    value: 'claude',
    label: 'Claude',
    icon: 'https://www.google.com/s2/favicons?sz=64&domain=https://claude.ai/',
    disabled: false,
    isDefault: false,
  },
  BING: {
    value: 'bing',
    label: 'Bing',
    icon: 'https://www.google.com/s2/favicons?sz=64&domain=https://www.bing.com',
    disabled: false,
    isDefault: false,
  },
};

export const DEFAULT_TRAFFIC_SOURCE = TRAFFIC_SOURCE_OPTIONS.CLASSIC_GOOGLE_SEARCH.value;

const NORMALIZE_SEGMENT_NAME_REGEX = /[_-]+/g;

export const MARKET_SEGMENT_PROVIDER_PATTERNS = [
  {
    providerKey: 'chatgpt',
    option: TRAFFIC_SOURCE_OPTIONS.CHATGPT,
    tokens: ['gpt 4o', 'gpt-4o', 'gpt4o', 'gpt4', 'gpt', 'openai', 'chatgpt', 'o3'],
  },
  {
    providerKey: 'gemini',
    option: TRAFFIC_SOURCE_OPTIONS.GEMINI,
    tokens: ['gemini'],
  },
  {
    providerKey: 'google_ai_mode',
    option: TRAFFIC_SOURCE_OPTIONS.GOOGLE_AI_MODE,
    tokens: ['ai mode', 'google ai mode'],
  },
  {
    providerKey: 'google_ai_overview',
    option: TRAFFIC_SOURCE_OPTIONS.GOOGLE_AI_OVERVIEW,
    tokens: ['ai overview', 'google ai overview'],
  },
  {
    providerKey: 'perplexity',
    option: TRAFFIC_SOURCE_OPTIONS.PERPLEXITY,
    tokens: ['perplexity', 'pplx'],
  },
  {
    providerKey: 'claude',
    option: TRAFFIC_SOURCE_OPTIONS.CLAUDE,
    tokens: ['claude', 'anthropic'],
  },
  {
    providerKey: 'bing',
    option: TRAFFIC_SOURCE_OPTIONS.BING,
    tokens: ['bing', 'copilot', 'microsoft'],
  },
];

export const getMarketSegmentProviderMeta = (segmentName = '') => {
  const defaultOption = TRAFFIC_SOURCE_OPTIONS.CLASSIC_GOOGLE_SEARCH;
  const normalizedSegmentName = segmentName ? segmentName.toLowerCase().replace(NORMALIZE_SEGMENT_NAME_REGEX, ' ') : '';

  if (!normalizedSegmentName) {
    return defaultOption;
  }

  const matchedPattern = MARKET_SEGMENT_PROVIDER_PATTERNS.find((pattern) =>
    pattern.tokens.some((token) => normalizedSegmentName.includes(token))
  );

  return matchedPattern ? matchedPattern.option : defaultOption;
};

/**
 * Countries where Google AI Mode is NOT yet available.
 * Google AI Mode is available in most countries worldwide apart from these
 * exceptions. Codes are listed in both alpha_2 and alpha_3 forms.
 */
export const GOOGLE_AI_MODE_UNSUPPORTED_COUNTRIES = new Set([
  // France
  'FR',
  'FRA',
  // Turkey
  'TR',
  'TUR',
  // China
  'CN',
  'CHN',
  // Iran
  'IR',
  'IRN',
  // North Korea
  'KP',
  'PRK',
  // Syria
  'SY',
  'SYR',
  // Cuba
  'CU',
  'CUB',
]);

/**
 * Get conditional traffic source options based on country
 * @param {string} countryCode - Country code (alpha_2 or alpha_3)
 * @returns {Object} Modified traffic source options with conditional enablement
 */
export const getConditionalTrafficSourceOptions = (countryCode) => {
  const normalizedCountryCode = (countryCode || '').trim().toUpperCase();
  const isGoogleAiModeSupported = !GOOGLE_AI_MODE_UNSUPPORTED_COUNTRIES.has(normalizedCountryCode);

  const modifiedOptions = {
    ...TRAFFIC_SOURCE_OPTIONS,
    GOOGLE_AI_MODE: {
      ...TRAFFIC_SOURCE_OPTIONS.GOOGLE_AI_MODE,
      disabled: !isGoogleAiModeSupported,
    },
  };

  // Sort options: enabled first, then disabled
  const sortedOptions = {};
  const enabledOptions = {};
  const disabledOptions = {};

  Object.entries(modifiedOptions).forEach(([key, option]) => {
    if (option.disabled) {
      disabledOptions[key] = option;
    } else {
      enabledOptions[key] = option;
    }
  });

  // Combine enabled options first, then disabled options
  Object.assign(sortedOptions, enabledOptions, disabledOptions);

  return sortedOptions;
};

export const DEFAULT_COMP_PREFERENCES = {
  old: [],
  new: [],
  isNewSet: false,
  isRegenerate: false,
  isCompetitorChangeFound: false,
};

export const DEFAULT_GPT_INSTRUCTION_PAYLOAD = {
  promptFor: '',
  promptConfig: {},
  tokenLimit: 3500,
  isPublicApi: false,
  // legacy params
  instruction: '',
  tag: null,
  model: '',
  stream: false,
  max_tokens: 3500,
  callbackInstruction: '',
};

export const TAG_GROUP_WISE_PANEL_DISPLAY_KEYS = {
  SINGLE_CUSTOMER_COMPETITOR_DATA: 'single_customer_competitor_data',
  SINGLE_CUSTOMER_COMPETITOR_DATA_PREVIEW: 'single_customer_competitor_data_preview',
  SIDE_BY_SIDE_CUSTOMER_COMPETITOR_DATA: 'side_by_side_customer_competitor_data',
  SIDE_BY_SIDE_CUSTOMER_COMPETITOR_DATA_PREVIEW: 'side_by_side_customer_competitor_data_preview',
  NO_CUSTOMER_COMPETITOR_DATA: 'no_customer_competitor_data',
};

export const TAG_GROUP_WISE_PANEL_DISPLAY = [
  {
    text: 'Single Customer / Competitor Data',
    value: TAG_GROUP_WISE_PANEL_DISPLAY_KEYS.SINGLE_CUSTOMER_COMPETITOR_DATA,
  },
  {
    text: 'Single Customer / Competitor Data with Preview',
    value: TAG_GROUP_WISE_PANEL_DISPLAY_KEYS.SINGLE_CUSTOMER_COMPETITOR_DATA_PREVIEW,
  },
  {
    text: 'Side-By-Side Customer / Competitor Data',
    value: TAG_GROUP_WISE_PANEL_DISPLAY_KEYS.SIDE_BY_SIDE_CUSTOMER_COMPETITOR_DATA,
  },
  {
    text: 'Side-By-Side Customer / Competitor Data with Preview',
    value: TAG_GROUP_WISE_PANEL_DISPLAY_KEYS.SIDE_BY_SIDE_CUSTOMER_COMPETITOR_DATA_PREVIEW,
  },
  {
    text: 'No Customer / Competitor Data',
    value: TAG_GROUP_WISE_PANEL_DISPLAY_KEYS.NO_CUSTOMER_COMPETITOR_DATA,
  },
];

export const SORTING_OPTIONS = [
  { text: 'Page Wise', value: 'page_wise' },
  { text: 'Highest Score', value: 'score_desc' },
  { text: 'Lowest Score', value: 'score_asc' },
  { text: 'Improved First', value: 'improved_desc' },
  // { "text": "A → Z", "value": "alpha_asc" },
  // { "text": "Z → A", "value": "alpha_desc" },
  // { text: 'Proposed First', value: 'proposed_desc' },
];
